// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/ingestionpb/v1/validation.proto (package unacast.boundaries.ingestionpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * PreliminaryValidationTypes are performed before any processing of boundaries.
 * These are to check the validation of the data structure and its conformity
 * with the database structure rather than validations of the boundaries themselves.
 * If any of these validation steps fail the files will not be uploaded and the client will be required
 * to fix their datasets.
 *
 * @generated from enum unacast.boundaries.ingestionpb.v1.PreliminaryValidationType
 */
export enum PreliminaryValidationType {
  /**
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * File issues
   *
   * GeoJson and CSV supported
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_UNEXPECTED_FILE_FORMAT = 1;
   */
  UNEXPECTED_FILE_FORMAT = 1,

  /**
   * File cannot be unmarshalled
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_MALFORMED_FILE = 2;
   */
  MALFORMED_FILE = 2,

  /**
   * The file size exceeds our processing capabilities
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_FILE_TOO_BIG = 3;
   */
  FILE_TOO_BIG = 3,

  /**
   * The number of polygons per file exceeds our processing capabilities
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_TOO_MANY_POLYGONS = 4;
   */
  TOO_MANY_POLYGONS = 4,

  /**
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_TOO_MANY_ROWS_FAILED = 5;
   */
  TOO_MANY_ROWS_FAILED = 5,

  /**
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_ONE_OR_ROWS_FAILED = 6;
   */
  ONE_OR_ROWS_FAILED = 6,

  /**
   * Polygon issues
   *
   * The provided polygon wasn't expected - e.g. Multipolygon
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_UNEXPECTED_POLYGON_TYPE = 20;
   */
  UNEXPECTED_POLYGON_TYPE = 20,

  /**
   * Field issues
   *
   * Detect both malicious and unsupported characters
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_INVALID_CHARACTERS = 50;
   */
  INVALID_CHARACTERS = 50,

  /**
   * TODO
   *
   * @generated from enum value: PRELIMINARY_VALIDATION_TYPE_INVALID_METADATA_FORMAT = 51;
   */
  INVALID_METADATA_FORMAT = 51,
}
// Retrieve enum metadata with: proto3.getEnumType(PreliminaryValidationType)
proto3.util.setEnumType(PreliminaryValidationType, "unacast.boundaries.ingestionpb.v1.PreliminaryValidationType", [
  { no: 0, name: "PRELIMINARY_VALIDATION_TYPE_UNSPECIFIED" },
  { no: 1, name: "PRELIMINARY_VALIDATION_TYPE_UNEXPECTED_FILE_FORMAT" },
  { no: 2, name: "PRELIMINARY_VALIDATION_TYPE_MALFORMED_FILE" },
  { no: 3, name: "PRELIMINARY_VALIDATION_TYPE_FILE_TOO_BIG" },
  { no: 4, name: "PRELIMINARY_VALIDATION_TYPE_TOO_MANY_POLYGONS" },
  { no: 5, name: "PRELIMINARY_VALIDATION_TYPE_TOO_MANY_ROWS_FAILED" },
  { no: 6, name: "PRELIMINARY_VALIDATION_TYPE_ONE_OR_ROWS_FAILED" },
  { no: 20, name: "PRELIMINARY_VALIDATION_TYPE_UNEXPECTED_POLYGON_TYPE" },
  { no: 50, name: "PRELIMINARY_VALIDATION_TYPE_INVALID_CHARACTERS" },
  { no: 51, name: "PRELIMINARY_VALIDATION_TYPE_INVALID_METADATA_FORMAT" },
]);

/**
 * @generated from message unacast.boundaries.ingestionpb.v1.FileValidationError
 */
export class FileValidationError extends Message<FileValidationError> {
  constructor(data?: PartialMessage<FileValidationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.ingestionpb.v1.FileValidationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FileValidationError {
    return new FileValidationError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FileValidationError {
    return new FileValidationError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FileValidationError {
    return new FileValidationError().fromJsonString(jsonString, options);
  }

  static equals(a: FileValidationError | PlainMessage<FileValidationError> | undefined, b: FileValidationError | PlainMessage<FileValidationError> | undefined): boolean {
    return proto3.util.equals(FileValidationError, a, b);
  }
}

/**
 * Either a CSV row or Feature (GeoJson)
 *
 * @generated from message unacast.boundaries.ingestionpb.v1.RowValidationError
 */
export class RowValidationError extends Message<RowValidationError> {
  constructor(data?: PartialMessage<RowValidationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.ingestionpb.v1.RowValidationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RowValidationError {
    return new RowValidationError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RowValidationError {
    return new RowValidationError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RowValidationError {
    return new RowValidationError().fromJsonString(jsonString, options);
  }

  static equals(a: RowValidationError | PlainMessage<RowValidationError> | undefined, b: RowValidationError | PlainMessage<RowValidationError> | undefined): boolean {
    return proto3.util.equals(RowValidationError, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.ingestionpb.v1.FieldValidationError
 */
export class FieldValidationError extends Message<FieldValidationError> {
  /**
   * @generated from field: string field = 1;
   */
  field = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<FieldValidationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.ingestionpb.v1.FieldValidationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldValidationError {
    return new FieldValidationError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldValidationError {
    return new FieldValidationError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldValidationError {
    return new FieldValidationError().fromJsonString(jsonString, options);
  }

  static equals(a: FieldValidationError | PlainMessage<FieldValidationError> | undefined, b: FieldValidationError | PlainMessage<FieldValidationError> | undefined): boolean {
    return proto3.util.equals(FieldValidationError, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.ingestionpb.v1.PreliminaryValidationError
 */
export class PreliminaryValidationError extends Message<PreliminaryValidationError> {
  /**
   * @generated from field: unacast.boundaries.ingestionpb.v1.PreliminaryValidationType type = 1;
   */
  type = PreliminaryValidationType.UNSPECIFIED;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from oneof unacast.boundaries.ingestionpb.v1.PreliminaryValidationError.data
   */
  data: {
    /**
     * @generated from field: unacast.boundaries.ingestionpb.v1.FileValidationError file = 10;
     */
    value: FileValidationError;
    case: "file";
  } | {
    /**
     * @generated from field: unacast.boundaries.ingestionpb.v1.RowValidationError row = 11;
     */
    value: RowValidationError;
    case: "row";
  } | {
    /**
     * @generated from field: unacast.boundaries.ingestionpb.v1.FieldValidationError field = 12;
     */
    value: FieldValidationError;
    case: "field";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PreliminaryValidationError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.ingestionpb.v1.PreliminaryValidationError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PreliminaryValidationType) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "file", kind: "message", T: FileValidationError, oneof: "data" },
    { no: 11, name: "row", kind: "message", T: RowValidationError, oneof: "data" },
    { no: 12, name: "field", kind: "message", T: FieldValidationError, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreliminaryValidationError {
    return new PreliminaryValidationError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreliminaryValidationError {
    return new PreliminaryValidationError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreliminaryValidationError {
    return new PreliminaryValidationError().fromJsonString(jsonString, options);
  }

  static equals(a: PreliminaryValidationError | PlainMessage<PreliminaryValidationError> | undefined, b: PreliminaryValidationError | PlainMessage<PreliminaryValidationError> | undefined): boolean {
    return proto3.util.equals(PreliminaryValidationError, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.ingestionpb.v1.PreliminaryValidationFailures
 */
export class PreliminaryValidationFailures extends Message<PreliminaryValidationFailures> {
  /**
   * @generated from field: repeated unacast.boundaries.ingestionpb.v1.PreliminaryValidationError errors = 1;
   */
  errors: PreliminaryValidationError[] = [];

  constructor(data?: PartialMessage<PreliminaryValidationFailures>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.ingestionpb.v1.PreliminaryValidationFailures";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: PreliminaryValidationError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PreliminaryValidationFailures {
    return new PreliminaryValidationFailures().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PreliminaryValidationFailures {
    return new PreliminaryValidationFailures().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PreliminaryValidationFailures {
    return new PreliminaryValidationFailures().fromJsonString(jsonString, options);
  }

  static equals(a: PreliminaryValidationFailures | PlainMessage<PreliminaryValidationFailures> | undefined, b: PreliminaryValidationFailures | PlainMessage<PreliminaryValidationFailures> | undefined): boolean {
    return proto3.util.equals(PreliminaryValidationFailures, a, b);
  }
}

